/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const classifier = {

    button: {
        rateSearch: `Vai atradi meklēto?`,
    },
    label: {
        fileDate: `Pievienots`,
        learnMore: `UZZINI VAIRĀK`,
        noClassificationRecords: `Neatrada klasifikācijas ierakstus`,
        noClassificationRecordsDescription: `Pēc norādītajiem meklēšanas kritērijiem neizdevās atrast klasifikāciju ierakstus`,
        relatedFiles: `Saistītās datnes`,
    },
    mainData: {
        dateInputToday: `Šodiena`,
        download: `Lejupielādēt`,
        insufficientSearchPhrase: `Meklēto rezultātu hierarhijā netiek rādīti visi atrastie rezultāti. Lūdzam papildināt meklējamo frāzi.`,
        language: `Klasifikācijas valoda`,
        level: `Līmenis`,
        search: `Meklēt klasifikācijā`,
        valuesOnDate: `Vērtības uz`,
        view: `Attēlot`,
        viewHierarchical: `Hierarhiski`,
        viewLinear: `Lineāri`,
        viewSettingsTitle: `Attēlošanas iestatījumi`,
    },
    passportItem: {
        abbreviation: `Saīsinājums`,
        area: `Lietošanas joma`,
        author: `Izstrādātājs`,
        availability: `Pieejamība`,
        classificationObject: `Klasificēšanas objekts`,
        codingSystem: `Lietotā kodēšanas sistēma, koda garums, līmeņu skaits`,
        contactPerson: `Kontaktpersona`,
        coResponsibleAuthority: `Līdzatbildīgā iestāde`,
        legalBasis: `Tiesiskais pamatojums`,
        mainAuthority: `Atbildīgā iestāde`,
        plannedRevision: `Plānotā aktualizēšana vai pārskatīšana`,
        publicated: `Publicēts`,
        publicationYear: `Izdošanas gads`,
        purpose: `Ieviešanas mērķis`,
        status: `Statuss`,
    },
    relatedBlock: {
        title: `Šim ierakstam ir saistīta klasifikācija/s`,
    },
    tabItems: {
        classifierAndDownloads: `Klasifikācija un lejupielādes`,
        passportData: `Pases dati`,
    },
    text: {
        downloadSuccess: `Datne veiksmīgi sagatavota`,
        rateSearchContent: `Palīdzi Mums pilnveidot meklētāju un novērtē, vai atrastie rezultāti Tev palīdzēja!`,
        rateSearchTitle: `Novērtē atrastos rezultātus!`,
        rateSuccess: `Vērtējums saņemts, paldies!`,
        relatedNotPublished: `Saistītā ieraksta attēlošana nav iespējama, jo Klasifikācija nav publicēta`,
        settingPlMsgDateFilter: `Tiek attēloti klasifikācijas ieraksti uz`,
    },
    tooltip: {
        searchThumbDown: `Šī nav klasifikācija, kuru meklēju!`,
        searchThumbUp: `Šī ir klasifikācija, kuru meklēju!`,
    },
}
